import type { ApolloError, ServerError } from '@apollo/client'
import type { NetworkError } from '@apollo/client/errors'

export function isServerError(error: NetworkError): error is ServerError {
  return typeof error === 'object' && 'statusCode' in error
}

export const getErrorMessage = (error: ApolloError): string => {
  return (error && error.message) || ''
}

export const errorMessageContains = (
  error: ApolloError,
  expectedString: string
) => {
  return getErrorMessage(error).toLowerCase().indexOf(expectedString) > -1
}

export const hasServerError = (error: ApolloError) => {
  return (error?.networkError as ServerError)?.response?.status === 500
}

export const requestErrorStatus = (error: ApolloError): number | null => {
  const hasNetworkError = error && error.networkError ? true : false
  const status =
    hasNetworkError && (error?.networkError as ServerError)?.response
      ? (error?.networkError as ServerError).response?.status
      : null
  return status
}

const ApiError = {
  getErrorMessage,
  errorMessageContains,
  hasServerError
}

export default ApiError
